import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const usageProfileModule: ModuleDefinition = {
    name: "usage-profile",

    install(_app: App, _options: ModuleOptions): void {
        // Initialisation du module
    },
}

export default usageProfileModule
